import React, { useRef } from 'react'
import { appToast } from '../../../../components/AppToast'

export default function MobileAppLogoUpload({ logoUrl, onLogoChange }) {
  const fileInputRef = useRef(null)

  const handleFile = (file) => {
    if (!file) return
    if (!file.type.startsWith('image/')) {
      appToast.warning('Please upload a valid image file (PNG, JPG, SVG).')
      return
    }
    const reader = new FileReader()
    reader.onload = (e) => {
      onLogoChange(e.target.result)
    }
    reader.readAsDataURL(file)
  }

  const handleDrop = (e) => {
    e.preventDefault()
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0])
    }
  }

  return (
    <div className="rounded-3xl border border-outline-variant/25 bg-surface-container-lowest p-6 shadow-xs">
      {/* Header */}
      <div className="flex items-center gap-2 text-primary font-bold text-sm border-b border-outline-variant/15 pb-4 mb-4">
        <span className="material-symbols-outlined text-base">branding_watermark</span>
        <span>Mobile App Logo &amp; Branding</span>
      </div>

      <div className="flex flex-col sm:flex-row items-center gap-5">
        {/* Logo Preview (50px x 50px size reference) */}
        <div className="relative flex flex-col items-center justify-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-2xl border-2 border-dashed border-outline-variant/40 bg-surface-container-low p-1 overflow-hidden shadow-inner">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt="App Logo Preview"
                className="h-full w-full object-contain rounded-xl"
              />
            ) : (
              <div className="flex flex-col items-center justify-center text-outline-variant">
                <span className="material-symbols-outlined text-3xl">image</span>
              </div>
            )}
          </div>
          <span className="mt-1 text-[10px] font-black uppercase text-on-surface-variant tracking-wider">
            50px × 50px
          </span>
        </div>

        {/* Upload Controls & Drag Zone */}
        <div
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleDrop}
          className="flex flex-1 flex-col items-center sm:items-start justify-center rounded-2xl border border-outline-variant/20 bg-surface-container-low/40 p-4 text-center sm:text-left transition hover:border-primary/40 w-full"
        >
          <p className="text-xs font-bold text-on-surface">Upload Institutional App Logo</p>
          <p className="text-[11px] text-on-surface-variant mt-0.5">
            Supported formats: PNG, JPG, WebP. Recommended dimensions: <b>50px × 50px</b>.
          </p>

          <input
            type="file"
            ref={fileInputRef}
            accept="image/*"
            className="hidden"
            onChange={(e) => {
              if (e.target.files && e.target.files[0]) {
                handleFile(e.target.files[0])
              }
            }}
          />

          <div className="mt-3 flex items-center gap-2">
            <button
              type="button"
              onClick={() => fileInputRef.current?.click()}
              className="flex items-center gap-1.5 rounded-xl bg-primary/10 px-3.5 py-1.5 text-xs font-bold text-primary hover:bg-primary/20 transition cursor-pointer"
            >
              <span className="material-symbols-outlined text-sm">upload</span>
              <span>{logoUrl ? 'Change Logo' : 'Select Image'}</span>
            </button>

            {logoUrl && (
              <button
                type="button"
                onClick={() => onLogoChange('')}
                className="flex items-center gap-1 rounded-xl border border-outline-variant/30 bg-surface-container-low px-3 py-1.5 text-xs font-bold text-rose-600 hover:bg-rose-50 transition cursor-pointer"
              >
                <span className="material-symbols-outlined text-sm">delete</span>
                <span>Remove</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
